import { imagePreviewActionTypes } from '@/components/modals/imagePreview/Constants';

import type { ImagePreviewData, SetImagePreviewAction } from './types';

export function setImagePreviewModal(data: ImagePreviewData): SetImagePreviewAction {
	return {
		type: imagePreviewActionTypes.SET_IMAGE_PREVIEW,
		payload: { data },
	};
}
